import React from "react";
import "./Bio.css";

const Bio = () => (
  <section id="about" className="bio-section">
    <h2>Bio</h2>
    <div className="bio-content">
      <p>
        PhD candidate at <strong>Tohoku University</strong>, under the guidance
        of Profs.{" "}
        <a
          href="http://www.iic.ecei.tohoku.ac.jp/~machi/index-e.html"
          target="_blank"
          rel="noreferrer"
        >
          Shinichiro Omachi
        </a>
        ,{" "}
        <a
          href="https://tomomiyazaki.github.io/"
          target="_blank"
          rel="noreferrer"
        >
          Tomo Miyazaki
        </a>
        , and{" "}
        <a
          href="https://hyongsong.work/"
          target="_blank"
          rel="noreferrer"
        >
          Yongsong Huang
        </a>
        .
      </p>
      <p>
        Research interests include Adversarial Attacks and Defense, Explainable
        Artificial Intelligence (XAI), Shortcut Learning, Knowledge
        Distillation, and Domain Generalization.
      </p>
      <p>
        Selected for the{" "}
        <a
          href="https://pgd.tohoku.ac.jp/english/rpc/next_generation_AI.html"
          target="_blank"
          rel="noreferrer"
        >
          JST NEXT-AI (BOOST) project
        </a>{" "}
        at Tohoku University.
      </p>
      <p>
        Contact available by email; resume available below.
      </p>
    </div>
  </section>
);

export default Bio;
